module.exports = __webpack_public_path__ + "static/media/ecosentino-white.f7334374.svg";